import { render, staticRenderFns } from "./GradientText.vue?vue&type=template&id=5ba6391c&scoped=true&"
import script from "./GradientText.vue?vue&type=script&lang=js&"
export * from "./GradientText.vue?vue&type=script&lang=js&"
import style0 from "./GradientText.vue?vue&type=style&index=0&id=5ba6391c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba6391c",
  null
  
)

export default component.exports